import type { SyntheticEvent } from "react";

/**
 * Fallback for broken/missing product images. Product image URLs are entered by
 * staff, so a bad URL shouldn't render a broken-image icon — swap in a branded
 * placeholder instead. A dataset flag guards against an error loop if the
 * placeholder itself ever fails.
 */
export const PLACEHOLDER_IMG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400">` +
      `<rect width="100%" height="100%" fill="#f2e9ff"/>` +
      `<text x="50%" y="50%" font-family="sans-serif" font-size="34" ` +
      `fill="#b79ae0" text-anchor="middle" dominant-baseline="middle">NApuff 💨</text>` +
      `</svg>`,
  );

export function handleImgError(e: SyntheticEvent<HTMLImageElement>): void {
  const el = e.currentTarget;
  if (el.dataset.fallback) return;
  el.dataset.fallback = "1";
  el.src = PLACEHOLDER_IMG;
}
